/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import { AvailabilityDelayEnum } from './availabilityDelayEnum';
import { NullEnum } from './nullEnum';

/**
 * @nullable
 */
export type TrainingServicePreferencesAvailabilityDelay = AvailabilityDelayEnum | NullEnum | null;

export const TrainingServicePreferencesAvailabilityDelay = {
  ...AvailabilityDelayEnum,
  ...NullEnum,
} as const;
